import { render, staticRenderFns } from "./TemperatureCard.vue?vue&type=template&id=2c01fe10&"
import script from "./TemperatureCard.vue?vue&type=script&lang=ts&"
export * from "./TemperatureCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports